import React, { useState, useImperativeHandle, useRef, forwardRef } from 'react';
import { FormGroup, Input, Select, DatePicker } from '@tencent/spaui';
import { AGENCYTYPE, COMPANYSCALE } from '../const/constant';
import CitySelect from '../components/CitySelect';
import './info-common.scss';

const baseState = {
  agency_name: '', // 服务商名称
  company_service_type: '', // 服务类型
  company_business: '', // 主营业务
  company_area_code: '', // 公司经营所在地
  company_address: '', // 公司地址
  company_introduction: '', // 公司简介
  company_homepage: '', // 公司网址
  company_population: '', // 公司规模
  company_created_time: '', // 成立时间
  company_team: '', // 团队构成
};

// const baseState = {
//   agency_name: '服务商名称', // 服务商名称
//   company_service_type: 2, // 服务类型
//   company_business: '主营业务', // 主营业务
//   company_area_code: 140200, // 公司经营所在地
//   company_address: '公司地址', // 公司地址
//   company_introduction: '公司简介', // 公司简介
//   company_homepage: 'http://www.aa.com', // 公司网址
//   company_population: 2, // 公司规模
//   company_created_time: "2022-04-07", // 成立时间
//   company_team: 'asdf' // 团队构成
// };

const FormExamStrateg: { [key: string]: any } = {
  // 服务商名称
  agency_name: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length > 50) {
      return '长度过长';
    }
    return false;
  },
  // 服务类型
  company_service_type: (value: any) => {
    if (value === '') {
      return '请选择服务类型';
    }
    return false;
  },
  // 主营业务
  company_business: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length > 50) {
      return '长度过长';
    }
    return false;
  },
  // 公司经营所在地
  company_area_code: (value: any) => {
    if (!value) {
      return '请选择公司经营所在地';
    }
    return false;
  },
  // 公司地址
  company_address: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length > 50) {
      return '长度过长';
    }
    return false;
  },
  // 公司简介
  company_introduction: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length > 400) {
      return '长度过长';
    }
    return false;
  },
  // 公司网址
  company_homepage: (value: any) => {
    if (!value) {
      // return '不能为空';
      return false; // 可以为空
    }
    if (value.length > 50) {
      return '长度过长';
    }
    if (/^https?:\/\/.+/.test(value)) {
      return false;
    }
    return '请输入正确网址';
  },
  // 公司规模
  company_population: (value: any) => {
    if (value === '') {
      return '请选择公司规模';
    }
    return false;
  },
  // 成立时间
  company_created_time: (value: any) => {
    if (!value) {
      return '请选择成立时间';
    }
    return false;
  },
  // 团队构成
  company_team: (value: any) => {
    if (!value) {
      return '不能为空';
    }
    if (value.length > 400) {
      return '长度过长';
    }
    return false;
  },
};

// const Feedback = (num: number, total: number) => (
//   <span>
//     <span className="spaui-input-feedback-count">{num}</span>
//     <span className="spaui-input-feedback-divider">/</span>
//     <span className="spaui-input-feedback-range">{total}</span>
//   </span>
// );

interface Props {
  children?: React.FunctionComponent<{ submit: () => void }>;
  onSubmit?: (data: any) => void;
  initData?: { [key: string]: any };
}

// 公司信息
// eslint-disable-next-line react/display-name
const BaseInfo: React.FC<Props> = forwardRef((props, cref) => {
  // 表单所有数据
  const [formData, setFormData] = useState<{ [key: string]: any }>({ ...baseState, ...props.initData });
  // 表单项检查
  const [formExam, setFormExam] = useState<{ [key: string]: any }>({});

  const setFormValue = (name: string, value: any) => {
    formData[name] = value;
    setFormData({ ...formData });
  };

  // 返回 true 代表表单正确
  const checkForm = (key: string): boolean => {
    const res = FormExamStrateg[key]?.(formData[key]);
    formExam[key] = res;
    setFormExam({ ...formExam });
    return !res;
  };

  const submit = () => {
    const result = Object.keys(FormExamStrateg).map((item) => checkForm(item));
    if (result.includes(false)) {
      return;
    }
    props.onSubmit?.(formData);
    return formData;
  };

  const Component = props.children;

  const contentRef = useRef();
  useImperativeHandle(cref, () => ({
    submit,
  }));

  return (
    <div ref={contentRef}>
      <div className="info-content">
        <div className="form-line">
          <span className="form-label">服务商名称</span>
          <FormGroup
            className="form-item"
            error={formExam.agency_name}
            // feedback={Feedback(formData['agency_name'].length, 50)}
          >
            <Input
              placeholder="请输入服务商名称"
              value={formData.agency_name}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('agency_name', value.trim());
                checkForm('agency_name');
              }}
              underlined
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">服务类型</span>
          <FormGroup
            className="form-item"
            error={formExam.company_service_type}
            // feedback={Feedback(formData['agency_name'].length, 50)}
          >
            <Select
              value={formData.company_service_type}
              data={Object.keys(AGENCYTYPE).map((item) => ({ value: item, label: AGENCYTYPE[item] }))}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('company_service_type', +value);
                checkForm('company_service_type');
              }}
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">公司主营业务</span>
          <FormGroup
            className="form-item"
            error={formExam.company_business}
            // feedback={Feedback(formData['agency_name'].length, 50)}
          >
            <Input
              placeholder="请输入公司主营业务"
              value={formData.company_business}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('company_business', value.trim());
                checkForm('company_business');
              }}
              underlined
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">公司经营所在地</span>
          <FormGroup className="form-item" error={formExam.company_area_code}>
            <CitySelect
              value={formData.company_area_code}
              onChange={(value = '') => {
                setFormValue('company_area_code', value);
                checkForm('company_area_code');
              }}
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">公司地址</span>
          <FormGroup
            className="form-item"
            error={formExam.company_address}
            // feedback={Feedback(formData['agency_name'].length, 50)}
          >
            <Input
              placeholder="请输入公司地址"
              value={formData.company_address}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('company_address', value.trim());
                checkForm('company_address');
              }}
              underlined
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">公司简介</span>
          <FormGroup
            className="form-item"
            error={formExam.company_introduction}
            // feedback={Feedback(formData['agency_name'].length, 50)}
          >
            <Input
              style={{ height: '148px' }}
              placeholder="请输入公司简介"
              value={formData.company_introduction}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('company_introduction', value.trim());
                checkForm('company_introduction');
              }}
              tagType="textarea"
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">公司网址</span>
          <FormGroup className="form-item" error={formExam.company_homepage}>
            <Input
              placeholder="请输入公司网址 https://xxxx"
              value={formData.company_homepage}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('company_homepage', value);
                checkForm('company_homepage');
              }}
              underlined
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">公司规模</span>
          <FormGroup
            className="form-item"
            error={formExam.company_population}
            // feedback={Feedback(formData['agency_name'].length, 50)}
          >
            <Select
              value={formData.company_population}
              data={Object.keys(COMPANYSCALE).map((item) => ({ value: item, label: COMPANYSCALE[item] }))}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('company_population', +value);
                checkForm('company_population');
              }}
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">公司成立时间</span>
          <FormGroup className="form-item" error={formExam.company_created_time}>
            <DatePicker
              date={formData.company_created_time}
              type="single"
              picker="date"
              optionalStartRelativeDays={-365 * 50}
              onChange={(event: EventTarget, value) => {
                setFormValue('company_created_time', value);
                checkForm('company_created_time');
              }}
            />
          </FormGroup>
        </div>

        <div className="form-line">
          <span className="form-label">团队构成</span>
          <FormGroup
            className="form-item"
            error={formExam.company_team}
            // feedback={Feedback(formData['agency_name'].length, 50)}
          >
            <Input
              style={{ height: '148px' }}
              placeholder={'团队构成包括\n总数：\n产品技术：\n运营策划：\n商务/销售：\n其他：'}
              value={formData.company_team}
              onChange={(event: EventTarget, value = '') => {
                setFormValue('company_team', value);
                checkForm('company_team');
              }}
              tagType="textarea"
            />
          </FormGroup>
        </div>
      </div>
      <div style={{ display: 'inline-block' }}>{Component && <Component submit={submit} />}</div>
    </div>
  );
});

export default BaseInfo;
